import React from 'react'
import AdminSettings from '../../Component/adminComp/AdminSettings'

const Settings = () => {
  return (
   <AdminSettings/>
  )
}

export default Settings